import { createGlobalStyle } from 'styled-components';
import bg from '../static/images/money-bg.jpg';
import bgGold from '../static/images/bg-dollar-gold-340x573.jpg';

export default createGlobalStyle`

  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    width: 100%;
    position: relative;
    left: 0;
    -webkit-overflow-scrolling: touch;
    line-height: 1.5em;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    font-size: 16px;
    margin: 0;
    padding: 0;
  }

  .content-wrap {
    width: calc(100% - 4px);
    max-width: 960px;
    margin: 0 auto;
    padding: 2px;
  }

  section {
    position: relative;
    margin: 10px auto;
    width: calc(100% - 40px);
    min-height: 600px;
    max-width: 400px;
    min-width: 320px;
    border-radius: 20px;
    background-image: url(${bg});
    background-size: cover;
    background-repeat: no-repeat;
    padding: 20px;
  }

  .inner-wrap {
    width: 100%;
    height: 100%;
    min-height: 600px;
    border-radius: 20px;
    background-image: url(${bgGold});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
  }

  h1 {
    font-family: 'Ubuntu';
    font-weight: 700;
    padding: 25px;
    text-align: center;
    font-size: 39px;
    line-height: 40px;
    margin: 0;
  }

  @media(max-width: 380px) {
    h1 {
      font-size: 36px;
    }
  }

  p {
    font-family: 'Raleway';
    text-align: center;
    font-size: 26px;
    font-weight: 500;
  }

  .checkbox-wrap {
    display: flex;
    justify-content: center;
    margin-bottom: 25px;
  }

  .check-single {
    margin: 0 15px;
  }

  label {
    font-family: 'Raleway';
    font-size: 26px;
    font-weight: 500;
    margin-left: 15px;
  }

  .css-checkbox {
    scale: 2.1;
  }

  .select-wrap {
    width: 60%;
    margin-left: 20%;
    margin-bottom: 25px;
  }

  .rs__dropdown-indicator {
    color: black !important;
  }

  .rs__indicator-separator {
    background-color: black;
    width: 2px;
  }

  .rs__placeholder,
  .rs__single-value {
    color: black;
    font-family: 'Raleway';
    font-size: 22px;
    font-weight: 500;
    padding-left: 15px;
  }

  .rs__control {
    min-height: 45px;
  }

  .rs__control:hover,
  .css-vcexc0-control:hover {
    border-color: '#2c58d6' !important;
  }

  .rs__control--is-Focussed {
    border-color: green;
  }

  .rs__value-container {
    text-align: center;
  }



  .bottom-section {
    width: 100%;
    min-height: 256px;
  }

  .dollar-holder {
    position: absolute;
    width: calc(100% - 40px);
    display: flex;
    justify-content: center;
  }

  .dollar-holder img {
    height: 100%;
    width: auto;
  }

  .end-text {
    color: black;
    font-family: 'Raleway';
    font-size: 26px;
    line-height: 35px; 
    font-weight: 500;
    padding: 0 15%;
    text-align: center;
  }

  @media(max-width: 380px) {
    .end-text {
      padding: 0 12%;
    }
  }

  .end-text-dollar {
    font-family: 'Ubuntu';
    font-weight: 700;
    font-size: 56px;
    line-height: 50px;
    text-align: center;
    margin: 2px 0 0 0;
    background: -webkit-linear-gradient(#0fa4a4, #1e4ca0);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    padding-bottom: 25px;
    padding-top: 10px;
  }

  footer p {
    margin: 25px 5px;
    font-size: 14px;
    line-height: 16px;
    text-align: left;
  }


  /*
  label {
    margin-left: 10px;
  }

  p {
    margin-top: 20px;
  }

  footer p {
    margin-top: 130px;
    font-size: 12px;
  }

  .reveal-text::first-letter {
    text-transform: capitalize;
  }

  .reveal-text {    
    padding-top: 30px;
    font-size: 20px;
  }
  */



`;
